import { isAfter } from 'date-fns';

const handleAfterTicketEndsOrSoldOutScheduled = ({
  entity,
  entityKey,
  allEntities,
  checkSoldOut,
  now,
}) => {
  if (!entity[entityKey]) {
    return { isScheduled: false, hasInvalidReference: false };
  }

  const referencedEntity = allEntities.find(e => e._id === entity[entityKey]);
  if (!referencedEntity) {
    return { isScheduled: false, hasInvalidReference: true };
  }

  if (referencedEntity.status !== 'enabled') {
    return { isScheduled: false, hasInvalidReference: true };
  }

  const referencedSaleEndOn = referencedEntity.saleEndOn
    ? new Date(referencedEntity.saleEndOn)
    : null;

  /**
   * If the reference doesn't have a sale end on we in a way turn this condition into `after ticket sold out`.
   * And only account for the sold out portion since the condition is sold out OR sale ends
   */
  if (referencedSaleEndOn == null) {
    return { isScheduled: !checkSoldOut(referencedEntity), hasInvalidReference: false };
  }

  return {
    isScheduled: !checkSoldOut(referencedEntity) && isAfter(referencedSaleEndOn, now),
    hasInvalidReference: false,
  };
};

export default handleAfterTicketEndsOrSoldOutScheduled;
